import { Component } from 'preact'
import ReactCrop from 'react-image-crop'
import FakeFileUploader from '../../control-components/ui-components/FakeFileUploader'
import { maxImageFileSize } from 'libs/constants'

class QuickLinkUploader extends Component {
  constructor (props) {
    super()
    this.state = {
      src: null,
      crop: {
        x: 0,
        y: 0,
        height: 80
      },
      pixelCrop: {},
      errorMessage: null
    }
    this.attachmentsUri = '/attachment/new'
    const element = document.getElementById('csrftoken')
    if (element) {
      this.csrf = element.value
    }
    this.fileInputId = props.fileInputId
  }

  onSelectFile (e, reader = new window.FileReader()) {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size > maxImageFileSize) { // 5MB
        this.setState({ errorMessage: 'Size is more than 5MB' })
        return
      }
      if (!['image/png', 'image/jpeg'].includes(e.target.files[0].type)) {
        this.setState({ errorMessage: 'File type is not supported' })
        return
      }
      reader.addEventListener('load', () => this.setState({ src: reader.result, errorMessage: null }))
      reader.readAsDataURL(e.target.files[0])
    }
  }

  onCropChange (crop, pixelCrop) {
    this.setState({ crop: crop, pixelCrop: pixelCrop })
  }

  saveImage (formData = new window.FormData()) {
    const file = document.getElementById(this.fileInputId).files[0]

    formData.append('image', file)
    formData.append('yip_csrf_token', this.csrf)
    formData.append('crop_coords[x]', Math.round(this.state.pixelCrop.x))
    formData.append('crop_coords[y]', Math.round(this.state.pixelCrop.y))
    formData.append('crop_coords[width]', Math.round(this.state.pixelCrop.width))
    formData.append('crop_coords[height]', Math.round(this.state.pixelCrop.height))

    this.sendXHRequest(formData, new window.XMLHttpRequest())
  }

  sendXHRequest (data, xhr = new window.XMLHttpRequest()) {
    xhr.addEventListener('readystatechange', (e) => this.onReadyStateChangeHandler(e), false)
    xhr.open('POST', this.attachmentsUri, true)
    xhr.send(data)
  }

  onReadyStateChangeHandler (evt) {
    try {
      if (evt.target.readyState === 4 && evt.target.status === 200 && evt.target.responseText) {
        document.getElementById(this.fileInputId).value = ''
        this.props.onUploaded(JSON.parse(evt.target.responseText).source_thumb)
      }
    } catch (e) {
      console.log('error', e)
    }
  }

  componentDidMount () {
    document.getElementById(this.fileInputId).value = ''
    const crop = Object.assign({}, this.state.crop, { aspect: this.props.width / this.props.height })
    this.setState({ crop })
  }

  render (props, state) {
    return (
      <div className='uploader'>
        <label>{props.label}</label>
        <span>Maximum file size: 5MB. Allowed image types: .jpg, .png. We recommend a minimum of {props.width}*{props.height}px</span>
        {state.errorMessage && (<div className='validation-error'>{state.errorMessage}</div>)}
        <FakeFileUploader width={props.width} height={props.height} hidden={state.src}>
          <input type='file' id={this.fileInputId} onChange={(e) => this.onSelectFile(e)} accept='image/png|image/jpeg' />
        </FakeFileUploader>
        {state.src && (
          <div>
            <span>{state.pixelCrop.width}*{state.pixelCrop.height}px selected</span>
            <div>
              <ReactCrop
                src={state.src}
                crop={state.crop}
                onChange={(crop, pixelCrop) => this.onCropChange(crop, pixelCrop)}
              />
            </div>
            <button
              className='btn btn-primary qa-quicklinks-upload-image' onClick={(e) => {
                e.preventDefault()
                this.saveImage()
              }}
            >Upload image</button>
          </div>
        )}
      </div>
    )
  }
}

export default QuickLinkUploader
